import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import NewJsonSetter from '../blocks/NewJsonSetter';
import CurrentJsonExtractor from '../blocks/CurrentJsonExtractor';
import { changeDashboardModels } from '../../../actions/individualPortal/dashboard/dashboardActionCreators';
import { configs } from '../../../constants/configs/configs';

const MemberHomeHyperDashboard = props => {

    const {
        data,
        changeDashboardModels
    } = props;

    const [ state, setState ] = useState({
        JsonSetter: false,
        JsonGetter: false
    });

    const {
        JsonSetter,
        JsonGetter
    } = state;

    const defaultButtonStyle = {
        padding: '5px 15px',
        borderRadius: '3px',
        cursor: 'pointer'
    };

    const handleToggle = ({ target: { name } }) => {
        setState(state => Object
            .keys(state)
            .reduce((newState, btn) => btn === name ? { ...newState, [name]: !state[name] } : { ...newState, [btn]: false }, {}));
    };

    useEffect(() => {
        const tooltipsCloseHandlers = e => {
            if(Object.keys(state).some(key => key === e.target.id)) {
                handleToggle({ target: { name: e.target.id } });
            }
        };
        window.addEventListener('click', tooltipsCloseHandlers);

        return () => window.removeEventListener('click', tooltipsCloseHandlers);
    }, []);

    const [ json, changeJson ] = useState('');
    const [ isApplyJsonButtonDisabled, toggleApplyJsonButtonDisability ] = useState(true);

    const refToJsonTextArea = useRef();

    const getButtons = () => {
        return Object.keys(state).map(btnName => {
            return (
                <button
                    key={btnName}
                    name={btnName}
                    onClick={ handleToggle }
                    style={{
                        ...defaultButtonStyle
                    }}
                >

                    {btnName}
                </button>
            );
        });
    };

    return (
        <div>
            <span style={{ fontWeight: 'bold', marginRight: '10px' }}>getDashboardModels</span>
            <div style={{ display: 'inline-block' }}>
                {
                    getButtons()
                }

                {
                    JsonSetter && <NewJsonSetter {...{
                        id: 'JsonSetter',
                        name: JsonSetter,
                        btnText: 'Apply JSON',
                        appType: configs.routes.INDPORTAL,
                        json,
                        changeJson,
                        isApplyJsonButtonDisabled,
                        toggleApplyJsonButtonDisability,
                        handleToggle,
                        changeData: changeDashboardModels
                    }} />
                }

                {
                    JsonGetter && <CurrentJsonExtractor {...{
                        id: 'JsonGetter',
                        name: JsonGetter,
                        buttons: [['Copy JSON to clipboard', 'dashboard']],
                        data,
                        refToJsonTextArea,
                        handleToggle
                    }} />
                }

            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    data: state.individualPortal.dashboard.dashboardModels
});

export default connect(mapStateToProps, { changeDashboardModels })(MemberHomeHyperDashboard);
